import { CssBaseline } from '@mui/material'
import Router from 'Router'
import Loader from 'SharedComponents/Loader'
import SnackBar from 'SharedComponents/SnackBar'
import { Provider } from 'react-redux'
import Store from 'Redux/Store'
import { ThemeProvider } from '@mui/material/styles'
import { ThemeProvider as ThemeProviderStyle } from '@mui/styles'
import theme from './Theme'
import NetworkService from 'Services/Network'
import { useState} from "react";
import { useSelector } from "react-redux";
import { LanguageProvider } from "./language";
// ThemeProvider -- Whole Mui Theme
// ThemeProviderStyle -- To Access the palette colors from makeStyles

NetworkService.setupInterceptors(Store)

const AppContent = () => {
  const userType = useSelector((state) => state?.AuthReducer?.userType || ""); 
  const [zoomLevel] = useState(0.9);

  return (
    <div style={userType === "HOTEL" ? {} : { zoom: zoomLevel }}>
      <ThemeProvider theme={theme}>
        <ThemeProviderStyle theme={theme}>
          <Loader />
          <SnackBar />
          <CssBaseline />
          <Router />
        </ThemeProviderStyle>
      </ThemeProvider>
    </div>
  );
};

const App = () => (
  <Provider store={Store}>
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  </Provider>
);

export default App
